import { Pipe, PipeTransform } from '@angular/core';
import { AuthStore } from '../../core/auth/services/auth.store';

@Pipe({
  name: 'authority',
})
export class HasAuthorityPipe implements PipeTransform {
  constructor(private authStore: AuthStore) {}
  transform(value: any, ...args: any[]): boolean {
    return this.authStore.hasAuthority(value);
  }
}
